<!--
 * @Description: 地址填写页面（老带新4.0）
 * @Autor: gxd
 * @Date: 2020-10-28 17:34:31
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-31 11:19:05
-->
<template>
  <div class="home">
    <div class="edit" v-if="state.isEdited">
      <div class="detail-wrapper clearfix">
        <div class="home-title">填写收货地址</div>
        <p class="home-desc">请您确认收货地址用于邮寄礼品</p>
        <div class="address">
          <div class="address-bar">
            <div class="row">
              <span class="address--lable">收货人</span>
              <input
                class="address--info__val"
                @blur="handleInputBlur"
                placeholder="收货人"
                maxlength="20"
                v-model="userInfo.name"
              />
            </div>
            <div class="row">
              <span class="address--lable">联系电话</span>
              <input
                class="address--info__val"
                @focus="onPhoneFocus"
                @blur="handleInputBlur"
                placeholder="联系电话"
                maxlength="11"
                v-model="userInfo.phone"
                type="tel"
              />
            </div>
            <div class="row" @click="$refs.picker.visible = true">
              <span class="address--lable">所在地区</span>
              <span class="address--info__val" :class="[userInfo.province_id === '' && 'gray']">
                {{
                  userInfo.province_id === ''
                    ? '所在地区'
                    : `${location.provinceName} ${location.cityName} ${location.countyName}`
                }}
              </span>
              <div class="right-icon">></div>
            </div>
            <div class="row">
              <span class="address--lable">详细地址</span>
              <input
                class="address--info__val"
                @blur="handleInputBlur"
                placeholder="详细地址"
                maxlength="100"
                v-model="userInfo.detail"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="confim-box">
        <div class="tips">注意：收货地址只支持提交一次，请确认或编辑后提交，提交后不可修改。</div>
        <div class="confim-btn" @click="handleBtnSubmit">保存并使用</div>
      </div>
    </div>
    <div class="check" v-else>
      <div class="detail-wrapper clearfix">
        <img class="check-correct" src="../assets/images/correct.png" alt />
        <p class="check-desc">填写成功</p>
        <div class="check-address">
          <div class="check-address-bar">
            <div class="check-row">
              <span class="address--lable">收货人</span>
              <div class="address--cont">{{ addrInfo.recipient_name }}</div>
            </div>
            <div class="check-row">
              <span class="address--lable">联系电话</span>
              <div class="address--cont">{{ addrInfo.recipient_phone }}</div>
            </div>
            <div class="check-row">
              <span class="address--lable">所在地区</span>
              <div class="address--cont">
                {{ addrInfo.province_name }}{{ addrInfo.city_name }}{{ addrInfo.county_name }}
              </div>
            </div>
            <div class="check-row">
              <span class="address--lable">详细地址</span>
              <div class="address--cont">{{ addrInfo.recipient_adds }}</div>
            </div>
          </div>
        </div>
        <p class="check-desc" @click="backHome">完成</p>
      </div>
      <div class="tips">注意：收货地址只支持提交一次，请确认或编辑后提交，提交后不可修改。</div>
    </div>
    <locationPicker ref="picker" @setLocation="handleSetLocation" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Validator from '../utils/Validator' // 参数校验
import locationPicker from '../components/locationPicker' // 省市联动组件
export default {
  name: 'home',
  computed: mapState(['selectedGift', 'defaultAddress', 'currentAllTimes']),
  components: {
    locationPicker
  },
  data () {
    return {
      state: {
        loginShow: false, // 登录窗
        loginstate: false, // 是否需要登录
        isEdited: true, // 用户是否已经填写过地址（是否处于可编辑状态）
        needAddress: true // 地址填写
      },
      // 地址填写完成展示数据
      addrInfo: {
        recipient_name: '',
        recipient_phone: '',
        province_name: '',
        city_name: '',
        county_name: '',
        recipient_adds: ''
      },
      // 地址默认获取与填写信息
      userInfo: {
        id: '', // 收货地址id
        name: '',
        phone: '',
        province_id: '',
        city_id: '',
        county_id: '',
        detail: ''
      },
      // 用户收货地址信息
      location: {
        provinceName: '',
        cityName: '',
        countyName: ''
      },
      // 物流地址
      logisticsInfo: {
        addrId: '', // 地址id
        name: '', // 收货人姓名
        phone: '', // 收货人手机号
        proId: '', // 所有所在省份
        citId: '', // 用户所在市、区
        couId: '', // 收货区县地址
        detail: '', // 地址详情
        note: '' // 备注信息
      }
    }
  },
  created () {
    this.$xesLogger.clickMsg({
      params: {
        elementname: '老带新收货地址页',
        element_action: 'pv',
        element_value: '收货地址页访问'
      }
    })
    this.$toast.loading({
      message: '加载中',
      mask: true,
      duration: 0
    })
    this.$api.checkLogin().then(res => {
      this.$toast.clear()
      if (res.stat === 1) {
        console.log('已登录======')
        this.state.loginstate = true
        this.addrInfos()
      } else {
        this.state.loginstate = false
        this.state.loginShow = true
      }
    })
  },
  mounted () {
    this.$xesLogger.opts.param.pageuid = 'winterActivity'
  },
  methods: {
    //  获取地址（中台）
    addrInfos () {
      console.log('addrInfo=====')
      this.$api.addrInfos().then((res) => {
        this.$toast.clear()
        if (res.stat !== 1) {
          return false
        }
        if (res.data.total !== 0) {
          let defAddr = {}
          for (const addr of res.data.list) {
            // 优先使用默认地址
            if (addr.is_default === '1') {
              defAddr = addr
            }
          }
          // 无默认地址，使用第一个地址
          if (Boolean(defAddr) === false) {
            defAddr = res.data.list[0]
          }
          this.userInfo = defAddr
          this.location.provinceName = defAddr.province_name || ''
          this.location.cityName = defAddr.city_name || ''
          this.location.countyName = defAddr.county_name || ''
          this.$store.dispatch('changeDefaultAddress', defAddr)
        }
      }).catch((e) => {
        this.$toast.clear()
        console.log(e)
      })
    },
    // 地址提交（中台）
    async handleBtnSubmit () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '老带新收货地址页',
          element_action: 'click',
          element_value: '“保存并使用”按钮点击'
        }
      })
      if (!this.state.loginstate) {
        this.$toast('当前没有登录！请先去登录')
        setTimeout(() => {
          this.state.loginShow = true
        }, 1000)
        return false
      }
      if (this.state.needAddress === true) {
        // 以下是地址填写逻辑
        const { userInfo } = this
        // 参数校验
        const validator = new Validator()
        const validateRes = validator
          .add(userInfo.name, 'isNotEmpty', '请填写收货人姓名')
          .add(userInfo.name, 'isValidName', '收货人姓名格式不规范，请修改后重新提交~')
          .add(userInfo.phone.replace(/\s/g, ''), 'isNotEmpty', '请输入收货人手机号')
          .add(userInfo.phone.replace(/\s/g, ''), 'isMobile', '请输入正确的手机号')
          .add(userInfo.province_id, 'isNotEmpty', '请选择所在地区')
          .add(userInfo.detail, 'isNotEmpty', '请输入详细地址')
          .add(userInfo.detail, 'isValidDetail', '详细地址内包含非法字符，请修改后重新提交~')
          .run()
        if (validateRes !== undefined) {
          this.$toast(validateRes)
          // 参数未能通过校验
          this.$xesLogger.clickMsg({
            params: {
              elementname: '老带新收货地址页',
              element_action: 'click',
              element_value: '老带新收货地址页-参数未通过校验'
            }
          })
          return false
        } else {
          // 参数已通过校验
          this.$xesLogger.clickMsg({
            params: {
              elementname: '老带新收货地址页',
              element_action: 'click',
              element_value: '老带新收货地址页-参数已通过校验'
            }
          })
        }
        this.$toast.loading({
          message: '订单地址保存中',
          mask: true,
          duration: 0
        })
        const payload = {
          addrId: userInfo.id || '', // 地址id
          name: userInfo.name, // 收货人姓名
          phone: userInfo.phone, // 收货人手机号
          proId: userInfo.province_id, // 省id
          citId: userInfo.city_id, // 市id
          couId: userInfo.county_id, // 区id
          detail: userInfo.detail, // 详细地址
          isDef: 1 // 是否为默认地址
        }
        if (userInfo.phone.includes('****')) {
          delete payload.phone
        }
        // 增、修地址 (若没有地址id(addrId),则为添加地址，反之为修改地址)
        await this.$api.addrMod(payload).then(res => {
          this.$toast.clear()
          if (res.stat === 1) {
            this.userInfo.id = res.data.id // 地址id
            this.addrInfo = {
              recipient_name: userInfo.name,
              recipient_phone: userInfo.phone,
              province_name: this.location.provinceName,
              city_name: this.location.cityName,
              county_name: this.location.countyName,
              recipient_adds: userInfo.detail
            }
            this.logisticsInfo = {
              addrId: res.data.id, // 地址id
              name: userInfo.name, // 收货人姓名
              phone: userInfo.phone, // 收货人手机号
              proId: userInfo.province_id, // 所有所在省份
              citId: userInfo.city_id, // 用户所在市、区
              couId: userInfo.county_id, // 收货区县地址
              detail: userInfo.detail, // 地址详情
              note: '' // 备注信息
            }
            // 地址增加/更新完成，弹框确认是否兑换
            this.state.isEdited = false
            this.$store.dispatch('showAddressPopup', true)
            this.$store.dispatch('changeDefaultAddress', res.data)
            this.$router.back()
          } else {
            this.$xesLogger.clickMsg({
              params: {
                elementname: '老带新收货地址页',
                element_action: 'click',
                element_value: '老带新收货地址页-增加/更新地址失败',
                data: `fail=${res.data}`
              }
            })
            this.$toast(res.data)
          }
        })
      }
    },
    // 回到首页
    backHome () {
      this.$router.back()
    },
    // 设置地址事件
    handleSetLocation (location) {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '老带新收货地址页',
          element_action: 'click',
          element_value: '老带新收货地址页-设置地址'
        }
      })
      const { provinceName, cityName, countyName, province_id, city_id, county_id } = location
      this.location = {
        provinceName,
        cityName,
        countyName
      }
      this.userInfo.province_id = province_id
      this.userInfo.city_id = city_id
      this.userInfo.county_id = county_id
    },
    // 防止iOS 全面屏点击漂移
    handleInputBlur () {
      setTimeout(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        document.getElementsByTagName('html')[0].scrollTop = scrollTop
        // 测试过程中发现只需要下面这一条即可
        document.getElementsByTagName('body')[0].scrollTop = scrollTop
      }, 0)
    },
    // 当用户想修改默认地址的手机号时 自动清空手机号
    onPhoneFocus () {
      // if (this.userInfo.phone.includes('****')) {
      //   this.userInfo.phone = ''
      // }
    },
    // 更改地址
    changeAddress () {
      this.state.isEdited = true // 调整为编辑转态
      this.addrInfos()
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../assets/scss/address/index.less');

.exchange-success-popup {
  .exchange-success-popup-close {
    background-color: darkorange;
  }
}
</style>
